/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.Discount = class Discount {
  constructor(selector) {
    this.selector = selector;
    this.discountButton = $(this.selector);
  }

  render() {
    const _this = this;
    this.discountButton.attr('data-style', 'zoom-in');
    return this.discountButton.click(function(e) {
      let searchParams;
      e.preventDefault();
      Ladda.create(this).start();
      const form = _this.discountButton.parents('form');
      if (form.attr('id').search(/customer/) > -1) {
        searchParams = _this.getFormParams(form, 'customer');
      } else if (form.attr('id').search(/pass/) > -1) {
        searchParams = _this.getFormParams(form, 'pass');
      }
      // reload page with args
      return window.location.search += '&' + searchParams.join('&');
    });
  }

  // returns all form params as an array of strings - eg.
  // ["pass[first_name]=Michael", "pass[email]=michael@punchpass.com"]
  getFormParams(form, objectName) {
    const serializedParams =
    form.serializeArray().filter(function(el) {
      const elementNameRegex = new RegExp('^' + objectName + '\\\[');
      return el.name.match(elementNameRegex);
    });
    const formParams = [];
    $.each(serializedParams, function(index, formParam) {
      const formParamNameRegex = new RegExp(objectName + '\\\[(.*)\\\]');
      const formParamName = formParam.name.match(formParamNameRegex)[1];
      return formParams[formParamName] = formParam.value;
    });
    return Object.keys(formParams).map(i => objectName + "[" + i + "]=" + encodeURIComponent(formParams[i]));
  }
};

$(document).ready(function() {
  if (!$('[data-behavior~=apply-discount]').length) { return; }
  window.discount = new App.Discount('[data-behavior~=apply-discount]');
  return window.discount.render();
});
